export default {
  login: {
    title: 'Admin Portal',
    button: 'Đăng nhập',
    message: {
      success: 'Đăng nhập thành công',
      invalid_email: 'Email không hợp lệ',
      invalid_password: 'Mật khẩu không hợp lệ'
    },
    email: 'Email',
    password: 'Mật khẩu'
  },
  navbar: {
    welcome: 'Xin chào',
    change_password: 'Thay đổi mật khẩu',
    logout: 'Đăng xuất'
  },
  sidebar: {
    admin: {
      title: '',
      dashboard: 'Giới thiệu',
      user: 'Quản lý Thành viên',
      enter_score: 'Nhập điểm',
      import: 'Nhập dữ liệu'
    }
  },
  route: {
    dashboard: 'Giới thiệu',
    not_found: 'Không tìm thấy trang',
    login: 'Đăng nhập',
    user: 'Quản lý người dùng',
    enter_score: 'Nhập điểm mã vạch',
    import: 'Nhập dữ liệu'
  },
  dashboard: {
    enter_score: {
      title: 'Nhập điểm'
    }
  },
  page_404: {
    error_404: 'Không tìm thấy trang',
    back_to_home: 'Quay về trang chủ'
  },
  user: {
    title: 'Danh sách Thành viên',
    add: 'Thêm mới',
    update: 'Cập nhật',
    cancel: 'Huỷ',
    edit: 'Sửa',
    detail: 'Chi tiết',
    delete: 'Xoá',
    yes: 'Đồng ý',
    no: 'Không',
    _empty: '',
    search: 'Tìm kiếm',
    table: {
      no: 'STT',
      id: 'ID',
      email: 'Email',
      name: 'Họ và tên',
      role_name: 'Vai trò'
    },
    form: {
      id: 'ID',
      email: 'Email',
      name: 'Họ và tên',
      role: 'Vai trò',
      password: 'Mật khẩu'
    },
    select: 'Lựa chọn',
    required: 'Bắt buộc',
    message: {
      update_successful: 'Cập nhật thành công.',
      update_failed: 'Cập nhật không thành công.',
      delete_confirm: 'Bạn có chắc chắn muốn xoá người dùng này không?',
      delete_canceled: 'Đã huỷ xoá',
      delete_failed: 'Xoá không thành công',
      delete_successful: 'Xoá thành công',
      add_successful: 'Thêm mới thành công.',
      add_failed: 'Thêm mới không thành công.'
    },
    role: {
      admin: 'Quản trị hệ thống',
      manager: 'Cán bộ',
      professor: 'Giảng viên',
      student: 'Sinh viên'
    },
    change_password: {
      title: 'Thay đổi mật khẩu',
      form: {
        current_password: 'Mật khẩu hiện tại',
        password: 'Mật khẩu mới',
        password_confirmation: 'Xác nhận lại mật khẩu'
      },
      button: {
        update: 'Cập nhật',
        cancel: 'Huỷ'
      },
      message: {
        change_successful: 'Thay đổi mật khẩu thành công',
        change_failed: 'Thay đổi mật khẩu không thành công',
        password_not_match: 'Mật khẩu xác nhận không giống mật khẩu mới'
      }
    }
  },
  pagination: {
    number_record_on_a_page: 'Hiển thị'
  },
  search: 'Tìm kiếm',
  enter_score: {
    title: 'Nhập điểm',
    term_name: 'Học kỳ',
    select_term_name: 'Lựa chọn học kỳ...',
    professor_name: 'Giảng viên',
    select_professor_name: 'Lựa chọn giảng viên...',
    course_name: 'Lớp học phần',
    select_course_name: 'Lựa chọn lớp học phần....',
    weight_endpoint: 'Trọng số điểm cuối kỳ',
    weight_midtermpoint: 'Trọng số điểm giữa kỳ',
    weight_attendancepoint: 'Trọng số điểm chuyên cần',
    export_barcode: 'Xuất bảng điểm mã vạch',
    export_excel: 'Xuất file Excel',
    save: 'Lưu lại',
    upload: 'Nhập điểm từ file',
    export_statistic: 'Xuất thống kê học phần',
    note: 'Ghi chú',
    statistic: 'Thống kê kết quả',
    input_note: 'Thêm ghi chú',
    table: {
      student_code: 'Mã SV',
      student_name: 'Họ và tên',
      student_birthday: 'Ngày sinh',
      student_class_name: 'Lớp',
      student_attendance_point: 'Điểm chuyên cần',
      student_midterm_point: 'Điểm giữa kỳ',
      student_end_point: 'Điểm cuối kỳ',
      student_total_point: 'Tổng điểm',
      info_point: 'Nhập giá trị theo thang điểm 10',
      warning_point: 'Điểm nhập chưa đúng'
    },
    page_total: 'Danh sách gồm {total} sinh viên',
    message: {
      invalid_enter_weight_attendancepoint: 'Trọng số điểm chuyên cần không hợp lệ',
      invalid_enter_weight_midtermpoint: 'Trọng số điểm giữa kỳ không hợp lệ',
      store_score_successful: 'Lưu bảng điểm thành công.',
      upload_score_successful: 'Tải lên bảng điểm thành công.',
      upload_score_failed: 'Có lỗi trong quá trình tải bảng điểm lên. Xin vui lòng kiểm tra lại nội dung file tải lên',
      warning_all_point: 'Có lỗi trong quá trình nhập điểm. Xin vui lòng kiểm tra lại'
    },
    setting: {
      title: 'Cấu hình bảng điểm',
      form: {
        president_info_label: 'Tiêu đề thừa uỷ quyền',
        sign_instead_of_lable: 'Ký thay',
        deputy_head_label: 'Chức danh người ký thay',
        head_of_training_label: 'Tên người ký',
        required: 'Bắt buộc',
        update: 'Cập nhật'
      },
      message: {
        add_successful: 'Cập nhật thành công',
        add_failed: 'Cập nhật không thành công. Xin vui lòng thử lại.'
      }
    }
  },
  import: {
    title: 'Nhập dữ liệu',
    table_name: 'Tên bảng nhập',
    upload: 'Tải lên',
    page_total: 'Danh sách gồm {total} bản ghi',
    select_table_name: 'Lựa chọn tên bảng',
    button_add: 'Thêm mới',
    refresh: 'Tải lại',
    table: {
      no: 'STT',
      id: 'ID',
      file_name: 'Tên file',
      table_name: 'Tên bảng nhập',
      status: 'Trạng thái',
      imported_by: 'Tải lên bởi',
      created_at: 'Thời gian bắt đầu',
      updated_at: 'Thời gian kết thúc'
    },
    success: 'Thành công',
    processing: 'Đang thực hiện',
    failed: 'Thất bại',
    message: {
      upload_backup_successful: 'Tải lên dữ liệu thành công.',
      upload_backup_failed: 'Có lỗi trong quá trình tải dữ liệu lên. Xin vui lòng kiểm tra lại nội dung file tải lên'
    },
    form: {
      table_name: 'Tên bảng nhập',
      select_table_name: 'Lựa chọn tên bảng',
      close: 'Đóng',
      upload: 'Tải lên',
      file: 'File',
      select_file: 'Chọn file',
      upload_tip: 'File tải lên phải có định dạng .csv / .xls / .xlsx và có dung lượng nhỏ hơn hoặc bằng 100M',
      error_file_type: 'File tải lên phải có định dạng .csv / .xls / .xlsx',
      error_file_size: 'File tải lên phải có dung lượng nhỏ hơn hoặc bằng 100M',
      required: 'Bắt buộc',
      export_exa_student_invalid: 'Tải về sanh sách thi bị lỗi sinh viên'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/vi.js